import React from "react";
import { Loader2, AlertTriangle, Inbox } from "lucide-react";

export function PageLoader({ label = "Loading" }) {
  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-3" data-testid="page-loader">
      <Loader2 className="h-7 w-7 animate-spin gold-text" />
      <p className="text-sm text-[color:var(--nq-stone)]">{label}...</p>
    </div>
  );
}

export function SkeletonGrid({ count = 6 }) {
  return (
    <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="card-nq animate-pulse">
          <div className="aspect-[16/10] w-full" style={{ background: "rgba(255,255,255,0.05)" }} />
          <div className="space-y-2 p-4">
            <div className="h-4 w-2/3 rounded" style={{ background: "rgba(255,255,255,0.07)" }} />
            <div className="h-3 w-full rounded" style={{ background: "rgba(255,255,255,0.05)" }} />
          </div>
        </div>
      ))}
    </div>
  );
}

export function ErrorState({ title = "Something went wrong", message, onRetry }) {
  return (
    <div className="flex min-h-[40vh] flex-col items-center justify-center gap-3 text-center" data-testid="error-state">
      <AlertTriangle className="h-8 w-8 text-[color:var(--destructive)]" style={{ color: "#d9534f" }} />
      <h3 className="text-lg font-semibold">{title}</h3>
      {message && <p className="max-w-md text-sm text-[color:var(--nq-stone)]">{message}</p>}
      {onRetry && (
        <button type="button" onClick={onRetry} className="btn-outline-nq mt-2" data-testid="error-retry-button">
          Try again
        </button>
      )}
    </div>
  );
}

export function EmptyState({ title = "Nothing here yet", message, action }) {
  return (
    <div
      className="flex flex-col items-center justify-center gap-3 rounded-xl border py-14 text-center"
      style={{ borderColor: "rgba(255,255,255,0.08)", background: "rgba(255,255,255,0.02)" }}
      data-testid="empty-state"
    >
      <Inbox className="h-8 w-8 text-[color:var(--nq-stone)]" />
      <h3 className="text-base font-semibold">{title}</h3>
      {message && <p className="max-w-md text-sm text-[color:var(--nq-stone)]">{message}</p>}
      {action}
    </div>
  );
}
